import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CustomizerProps } from '../../../../shared/prop-types/ReducerProps';

class ToggleSquared extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    customizer: CustomizerProps.isRequired,
    changeBorderRadius: PropTypes.func.isRequired,
  };

  render() {
    const { t, changeBorderRadius, customizer } = this.props;

    return (
      <label className="toggle-btn customizer__toggle" htmlFor="square_toggle">
        <input
          className="toggle-btn__input"
          type="checkbox"
          name="square_toggle"
          id="square_toggle"
          checked={customizer.squaredCorners}
          onChange={changeBorderRadius}
        />
        <span className="toggle-btn__input-label" />
        <span>{t('toggle_squared.borders')}</span>
      </label>
    );
  }
}

export default withTranslation('common')(ToggleSquared);
